/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';
const initialState = {
  planType: [],
  rebateProgram: [],
  selectedPlanType: '',
  rebateProgramName: {},
  allRebateProgram: false,
  isLoading: false,
  isAllManufacturersSelected: true,
  errorMessages: [],
  manufacturerList: [],
  searchResult: [],
  manufacturerSelected: [],
  selectRowIndex: null,
  planTypeToggle: '',
  displayObj: {
    planType: [],
    rebateProgram: [],
    selectedPlanType: '',
    rebateProgramName: {},
    rebateProgrameName: '',
    allRebateProgram: false,
    isAllManufacturersSelected: true,
    searchResult: [],
    manufacturerSelected: [],
    selectRowIndex: null,
  },
};
export const reducer = (state = initialState, Action) => {
  switch (Action.type) {
    //Plan type and rebate program
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: Action.payload };
    case ActionTypes.GET_ERROR_MSG_OUTSTANDING_BAL_LABERER_QTR:
      return { ...state, errorMessages: Action.payload };

    //Manufacturer Grid
    case ActionTypes.GET_MANUFACTURERS_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, manufacturerList: Action.manufacturerList };

    //To pass the selected option from req screen to disp screen
    case ActionTypes.SET_SELECTED_RESULT_OUTSTANDING_DISPUTES_QUARTER:
      return { ...state, ...Action.payload };

    //For Search Screen Header
    case ActionTypes.SET_OUTSTANDING_BAL_BY_LABERER_AND_QUARTER:
      let displayObj = {
        ...state.displayObj,
        searchResult: Action.searchResult,
      };
      return {
        ...state,
        searchResult: Action.searchResult,
        displayObj,
      };

    //loader
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Action.isLoading };
    //refresh
    case ActionTypes.REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR:
      return {
        ...state,
        isAllManufacturersSelected: true,
        allRebateProgram: false,
        rebateProgram: '',
        planType: '',
      };
    case ActionTypes.REFRESH_OUTSTANDING_BALANCE_BY_LABERER_AND_QTR_DISPLAY:
      return {
        ...state,
        isAllManufacturersSelected: true,
        allRebateProgram: false,
        rebateProgram: '',
        planType: '',
      };
    default:
      return state;
  }
};

export default reducer;
